import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { services } from '../data/services';
import { legalPages } from '../data/legal';
import { company } from '../data/company';
const SITE = company.name;
const baseMeta: Record<string, {
  title: string;
  description: string;
}> = {
  '/': {
    title: `Professional Fiduciary Services | Trust & Estate Administration | ${SITE}`,
    description: 'Professional fiduciary services including trust administration, probate administration, conservatorship services, personal fiduciary care and care management for individuals and families.'
  },
  '/about': {
    title: `About Us | Professional Fiduciary Services | ${SITE}`,
    description: 'A professional partner for trusts, estates, personal affairs and care-related responsibilities — private, dependable fiduciary administration.'
  },
  '/services': {
    title: `Fiduciary Services | Trust, Estate & Conservatorship Administration | ${SITE}`,
    description: 'Trust administration, special needs trust administration, POA & AHCD services, conservatorship services, probate administration, private fiduciary care and care management.'
  },
  '/contact': {
    title: `Contact a Professional Fiduciary | ${SITE}`,
    description: 'Contact us to discuss trust administration, probate administration, conservatorship support, personal fiduciary care or care management services.'
  }
};
services.forEach(service => {
  baseMeta[service.path] = {
    title: `${service.name} | Professional Fiduciary Services | ${SITE}`,
    description: service.intro
  };
});
legalPages.forEach(page => {
  baseMeta[page.path] = {
    title: `${page.title} | ${SITE}`,
    description: page.intro
  };
});
export function SeoMeta() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    const meta = baseMeta[pathname] ?? {
      title: `Page Not Found | ${SITE}`,
      description: 'Professional fiduciary, trust, estate and care administration services.'
    };
    document.title = meta.title;
    let tag = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    if (!tag) {
      tag = document.createElement('meta');
      tag.setAttribute('name', 'description');
      document.head.appendChild(tag);
    }
    tag.setAttribute('content', meta.description);
  }, [pathname]);
  return null;
}